import { FC } from 'react'
import ROUTES from '@client-hub/shared/constants/routes'
import { useHubTokenValidation } from 'hooks/auth'
import RouteGuardBase from 'components/RouteGuardBase'

const HubNoAuthGuard: FC = (props) => {
  const [isValid, { isLoading }] = useHubTokenValidation()
  return <RouteGuardBase {...props} loading={isLoading} redirect={isValid} redirectTo={ROUTES.BASE} />
}

export default HubNoAuthGuard
